import React from 'react';

import { Icon } from '@chakra-ui/react';

export const HighRiskIcon = props => (
  <Icon viewBox="0 0 720 720" h="full" w="full" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M640 14.4C449.092 14.4 294.364 169.128 294.364 360 294.344 550.868 449.059 705.614 639.928 705.636 639.952 705.636 639.976 705.636 640 705.636 830.836 705.636 985.6 550.908 985.6 360 985.6 169.128 830.836 14.4 640 14.4ZM366.364 360C366.394 208.895 488.912 86.4238 640.018 86.4533 703.227 86.4655 764.484 108.364 813.376 148.428L428.392 533.412C388.213 484.56 366.283 423.252 366.364 360ZM639.964 633.564C576.737 633.661 515.449 611.744 466.624 571.572L851.608 186.624C947.343 303.534 930.174 475.916 813.264 571.648 764.38 611.68 703.148 633.553 639.964 633.564Z"
          fill="#C00000"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
